import { mapGetters } from 'vuex';
import mvtCollapse from '@/common/components/mvtcollapse/mvt-collapse.vue';
import mvtEstPriceChart from '@/common/components/mvtestprice/mvt-estpricechart.vue';

export default {
    name: 'propertyEstimate',
    inject: ['$eventBus'],
    components: {
        mvtCollapse,
        mvtEstPriceChart,
    },
    props: ['disableCollapse', 'isActive', 'isMarket5YLoaded'],
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('dpp', ['dpp', 'getEstRentFee', 'getEstimatePriceRange', 'getEstimateInfo']),
        priceChanged() {
            return this.dpp.forecast && this.dpp.forecast.lastMonthPrice && this.estPrice ? this.estPrice - this.dpp.forecast.lastMonthPrice : 0;
        },
        isIncrease() {
            return this.priceChanged > 0;
        },
        hasChartData() {
            return this.dpp.market5Y?.dailyCityStatisticsList?.length;
        }
    },
    methods: {
        ...mapGetters('glb', ['getComplianceMethod']),
        showNotSupportedByMLS() {
            const compliance = this.getComplianceMethod()();
            return compliance?.[0]?.rule?.includes('showNotSuportByMLS');
        },
    },
};
